/**
 * @module cercaliagl/view/VWeatherInformation
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import $ from 'jquery';
import BaseView from './BaseView';
/**
 * @classdesc
 */
var VWeatherInformation = /** @class */ (function (_super) {
    __extends(VWeatherInformation, _super);
    /**
     * @constructor
     */
    function VWeatherInformation() {
        var _this = this;
        var jqElement = $('<div class="v-weatherinformation mdc-elevation--z4"></div>');
        _this = _super.call(this, jqElement) || this;
        /**
         * @private
         * @type {import("../LonLat.js").default|undefined}
         */
        _this.position_ = undefined;
        /**
         * @private
         * @type {Date}
         */
        _this.currentDate = undefined;
        return _this;
    }
    /**
     * @private
     */
    VWeatherInformation.prototype.render_ = function () {
        var html = "<span class=date-info>".concat(this.currentDate.toLocaleString(), "</span>");
        this.jqElement_
            .empty()
            .append(html);
        this.show();
    };
    /**
     * @param {number} timestamp Timestamp.
     * @api
     */
    VWeatherInformation.prototype.updateData = function (timestamp) {
        this.currentDate = new Date(timestamp * 1000);
        this.render_();
    };
    return VWeatherInformation;
}(BaseView));
export default VWeatherInformation;
//# sourceMappingURL=VWeatherInformation.js.map